import { Button } from '@mantine/core';
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router';

export default function NotificationLinkButton({
  to,
  onClose,
  primary,
  children,
}: {
  to: string;
  onClose: () => void;
  primary?: boolean;
  children: ReactNode;
}) {
  const navigate = useNavigate();

  return (
    <Button
      size="sm"
      variant={primary ? 'primary' : 'default'}
      onClick={event => {
        event.stopPropagation();
        navigate(to);
        onClose();
      }}
    >
      {children}
    </Button>
  );
}
